import React, { useState, useEffect } from "react";
import {
  FaLinkedin,
  FaUser,
  FaBars,
  FaTimes,
  FaChevronDown,
  FaChevronUp,
} from "react-icons/fa";
import { RiMenuFill } from "react-icons/ri";
import styles from "../../lib/Common/commonStyles";
import "../../styles/header.css";
import { buildWebsiteUrl, WEBSITE_BASE_URL } from "../../apis/apiKit";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n/i18n";

function Header({ contract }) {
  const currentLanguage = i18n.language;
  const { t } = useTranslation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isAboutUsDropdownOpen, setIsAboutUsDropdownOpen] = useState(false);
  const [isMobileAboutUsOpen, setIsMobileAboutUsOpen] = useState(false);
  const queryParams = new URLSearchParams(window.location.search);
  const paramValue = false; //queryParams.get("lang");

  const [savedLanguage, setSavedLanguage] = useState(
    paramValue || localStorage.getItem("language") || "de"
  );
  // const savedLanguage = localStorage.getItem("language") || "en";
  useEffect(() => {
    if (paramValue) {
      // setSavedLanguage(paramValue);
      i18n.changeLanguage(paramValue);
      localStorage.setItem("language", paramValue);
    } else {
      setTimeout(() => {
        const saved = localStorage.getItem("language");
        if (saved) {
          setSavedLanguage(saved);
        }
      }, 100);
    }
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleAboutUsDropdown = () => {
    setIsAboutUsDropdownOpen(!isAboutUsDropdownOpen);
  };

  const toggleMobileAboutUs = () => {
    setIsMobileAboutUsOpen(!isMobileAboutUsOpen);
  };

  return (
    <div className="bg-white position-relative w-100 header-full-width">
      {/* Desktop Header */}
      <div className="d-none d-lg-block pt-2">
        <div className="bg-white">
          <div className="container header-edge-container">
            <div className="d-flex justify-content-end align-items-center py-2 ">
              <div className="d-flex align-items-center">
                <div className="d-flex align-items-center me-3 ">
                  <div className="align-self-center">
                    <a
                      href={buildWebsiteUrl(
                        currentLanguage == "en"
                          ? "/help-support/#Contactus"
                          : "/hilfe-support/#Contactus"
                      )}
                      className=" me-3 text-center text-decoration-none fontSize12Medium lineHeight24 text-blue"
                    >
                      {t("Contact")}
                    </a>
                    <a
                      href={buildWebsiteUrl(
                        currentLanguage == "en" ? "/careers" : "/karriere/"
                      )}
                      className=" text-decoration-none me-3 text-center fontSize12Medium lineHeight24 text-blue"
                    >
                      {t("Careers")}
                    </a>
                  </div>
                  <a
                    href="https://www.linkedin.com/company/greenman-energy/"
                    className=" text-decoration-none me-3 text-center text-blue"
                  >
                    <FaLinkedin size={20} />
                  </a>
                </div>
                {/* Buttons top */}

                <div className="d-flex gap-2 gap-md-3 gap-lg-4">
                  <button
                    className="header-switch-btn border-0 d-inline-flex align-items-center text-decoration-none rounded-pill btn backgroundColorGreen text-blue fontSize12Bold"
                    style={{
                      ...styles.btn_portal_custom,
                    }}
                    onClick={() => {
                      window.location.href =
                        currentLanguage == "en"
                          ? WEBSITE_BASE_URL + "/homepage"
                          : WEBSITE_BASE_URL;
                    }}
                  >
                    {t("Switch Now")}
                  </button>
                  {/* TODO no custom portal link has been provided */}
                  <div className="header-portal-container">
                    <button
                      className="header-portal-btn text-white d-inline-flex align-items-center overflow-hidden position-relative text-center rounded-pill btn fontSize12Bold backgroundColorLightBlue minWidth170"
                      style={{
                        ...styles.paddingV10H16,
                      }}
                      onClick={() => {
                        window.open("https://portal.greenman.energy/");
                      }}
                    >
                      <span className="z-1 text-center paddingR40">
                        {t("Customer Portal")}
                      </span>
                      <span className="top-0 left-0 end-0 float-right bottom-0 position-absolute z-2 d-flex align-items-center justify-content-center rounded-circle textGreen backgroundColorBlue width40 header-portal-circle-btn">
                        <FaUser size={16} />
                      </span>
                    </button>
                  </div>
                </div>
                <div className="d-flex align-items-center gap-2 ms-2">
                  <span
                    className={`text-decoration-none ${
                      savedLanguage !== "en"
                        ? "fontSize14Regular text-blue"
                        : "fontSize14Regular textGreen"
                    }`}
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      i18n.changeLanguage("en");
                      localStorage.setItem("language", "en");
                      setSavedLanguage("en");
                    }}
                  >
                    EN
                  </span>
                  <span className="fontSize14Regular text-blue mb-1">|</span>
                  <span
                    className={`text-decoration-none ${
                      savedLanguage !== "de"
                        ? "fontSize14Regular text-blue"
                        : "fontSize14Regular textGreen"
                    }`}
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      i18n.changeLanguage("de");
                      localStorage.setItem("language", "de");
                      setSavedLanguage("de");
                    }}
                  >
                    DE
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white">
          <div className="container header-edge-container">
            <div className="row align-items-center pb-3">
              {contract && (
                <div className="col-auto cursor-pointer">
                  <img
                    src={require("../../assets/images/gme_logo_green.png")}
                    alt="Greenman Energy"
                    className="img-fluid marginNTop20 maxWidth200 width200 h-auto mb-3 "
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                    onClick={() => {
                      window.open(
                        currentLanguage == "en"
                          ? WEBSITE_BASE_URL + "/homepage/"
                          : WEBSITE_BASE_URL
                      );
                    }}
                  />
                </div>
              )}

              {/*  Menu */}
              <div className="col">
                <nav className="d-flex align-items-center justify-content-end">
                  <a
                    href={buildWebsiteUrl(
                      currentLanguage == "en"
                        ? "/for-home"
                        : "/fur-privathaushalte/"
                    )}
                    className="header-nav-link nav-link me-3 me-lg-4 text-decoration-none text-blue fontSize16Medium"
                  >
                    {t("For Home")}
                  </a>
                  <a
                    href={buildWebsiteUrl(
                      currentLanguage == "en"
                        ? "/for-business"
                        : "/fur-geschaeftskunden/"
                    )}
                    className="header-nav-link nav-link me-3 me-lg-4 text-decoration-none text-blue fontSize16Medium"
                  >
                    {t("For Business")}
                  </a>
                  <a
                    href={buildWebsiteUrl(
                      currentLanguage == "en" ? "/e-mobility" : "/e-mobilitaet/"
                    )}
                    className="header-nav-link nav-link me-3 me-lg-4 text-decoration-none fontSize16Medium text-blue lineHeight24"
                  >
                    {t("E-Mobility")}
                  </a>
                  <a
                    href={buildWebsiteUrl(
                      currentLanguage == "en"
                        ? "/help-support"
                        : "/hilfe-support/"
                    )}
                    className="header-nav-link nav-link me-3 me-lg-4 text-decoration-none fontSize16Medium lineHeight24 text-blue"
                  >
                    {t("Help & Support")}
                  </a>

                  {/* About Us section*/}
                  <div className="position-relative">
                    <button
                      className="header-nav-link nav-link text-decoration-none fontSize16Medium lineHeight24 text-blue border-0 bg-transparent d-flex align-items-center"
                      onClick={toggleAboutUsDropdown}
                      style={{ cursor: "pointer" }}
                    >
                      {t("About Us")}
                    </button>

                    {isAboutUsDropdownOpen && (
                      <div
                        className="position-absolute backgroundColorpaleBlue shadow-lg  mt-2 end-0 minWidth210"
                        style={{
                          zIndex: 1050,
                        }}
                      >
                        <div className="py-2">
                          <a
                            href={buildWebsiteUrl(
                              currentLanguage == "en"
                                ? "/our-company"
                                : "/ueber-uns/unser-unternehmen/"
                            )}
                            className="header-nav-link d-block px-3 py-2 text-decoration-none text-blue fontSize16Medium "
                          >
                            {t("Our Company")}
                          </a>
                          <a
                            href={buildWebsiteUrl(
                              currentLanguage == "en"
                                ? "/our-energy-network"
                                : "/ueber-uns/unser-energienetz/"
                            )}
                            className=" header-nav-link d-block px-3 py-2 text-decoration-none text-blue fontSize16Medium "
                          >
                            {t("Our Energy Network")}
                          </a>
                          <a
                            href={buildWebsiteUrl(
                              currentLanguage == "en"
                                ? "/news-room"
                                : "/ueber-uns/aktuelles/#/"
                            )}
                            className="header-nav-link d-block px-3 py-2 text-decoration-none text-blue fontSize16Medium "
                          >
                            {t("News Room")}
                          </a>
                        </div>
                      </div>
                    )}
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile/ Tablet Header here */}
      <div className="d-block d-lg-none">
        <div className="border-light backgroundColorBlue">
          <div className="container header-edge-container">
            <div className="d-flex justify-content-between align-items-center py-2">
              <div className="d-flex align-items-center gap-2 gap-sm-3 gap-md-4">
                <button
                  className="header-switch-btn border-0 d-inline-flex  text-decoration-none rounded-pill btn backgroundColorGreen fontSize12Bold lineHeight18 text-blue minWidth100 align-items-center justify-content-center"
                  style={styles.paddingV10H16}
                  onClick={() => {
                    window.location.href = WEBSITE_BASE_URL;
                  }}
                >
                  {t("Switch Now")}
                </button>

                <div className="header-portal-container-mobile">
                  <button
                    className="header-portal-mobile-btn border-0 text-white d-inline-flex align-items-center overflow-hidden position-relative text-center rounded-pill fw-bold btn backgroundColorLightBlue fontSize12Bold lineHeight18 paddingR40 minWidth100"
                    style={styles.paddingV10H16}
                    onClick={() => {
                      window.open("https://portal.greenman.energy/");
                    }}
                  >
                    <span className="z-1 text-center">
                      <span>{t("Portal")}</span>
                    </span>
                    <span className="header-portal-circle-mobile-btn top-0 left-0 end-0 float-right bottom-0 position-absolute z-2 d-flex align-items-center justify-content-center rounded-circle backgroundColorPink text-white width40">
                      <FaUser size={16} />
                    </span>
                  </button>
                </div>
              </div>

              <div className="d-flex align-items-center gap-1 ">
                <span
                  className={`text-decoration-none ${
                    savedLanguage === "en"
                      ? "fontSize14Regular textGreen "
                      : "fontSize14Regular text-white"
                  }`}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    i18n.changeLanguage("en");
                    localStorage.setItem("language", "en");
                    setSavedLanguage("en");
                  }}
                >
                  EN
                </span>
                <span className="fontSize14Regular text-white text-center mb-1">
                  |
                </span>
                <span
                  className={`text-decoration-none ${
                    savedLanguage === "de"
                      ? "fontSize14Regular textGreen "
                      : "fontSize14Regular text-white"
                  }`}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    i18n.changeLanguage("de");
                    localStorage.setItem("language", "de");
                    setSavedLanguage("de");
                  }}
                >
                  DE
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white">
          <div className="container header-edge-container">
            <div className="d-flex align-items-center justify-content-between py-3">
              {contract && (
                <div className="flex-shrink-0 cursor-pointer ">
                  <img
                    src={require("../../assets/images/gme_logo_green.png")}
                    alt="Greenman Energy"
                    className="img-fluid h-auto maxWidth150 w-auto "
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                    onClick={() => {
                      window.open(WEBSITE_BASE_URL);
                    }}
                  />
                </div>
              )}

              <button
                className="border-0 rounded backgroundColorGreen text-blue"
                type="button"
                onClick={toggleMobileMenu}
                aria-expanded={isMobileMenuOpen}
                aria-label="Toggle navigation"
                style={{
                  ...styles.paddingV10H18,
                }}
              >
                {isMobileMenuOpen ? (
                  <FaTimes size={18} />
                ) : (
                  <RiMenuFill size={18} />
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/*  Mobile Dropdown Menu */}
      {isMobileMenuOpen && (
        <div
          className="header-mobile-dropdown position-absolute top-100 start-0 end-0 bg-white shadow-lg d-lg-none"
          style={{ zIndex: 1050 }}
        >
          <div className="container header-edge-container">
            <div className="row">
              <div className="col-12">
                <div className="d-flex flex-column">
                  <a
                    href={buildWebsiteUrl(
                      currentLanguage == "en"
                        ? "/for-home"
                        : "/fur-privathaushalte/"
                    )}
                    className="header-nav-link text-decoration-none py-3 border-bottom px-2 px-sm-3 text-blue fontSize18Medium lineHeight24"
                  >
                    {t("For Home")}
                  </a>
                  <a
                    href={buildWebsiteUrl(
                      currentLanguage == "en"
                        ? "/for-business"
                        : "/fur-geschaeftskunden/"
                    )}
                    className="text-decoration-none py-3 border-bottom px-2 px-sm-3 text-blue fontSize18Medium lineHeight24 header-nav-link"
                  >
                    {t("For Business")}
                  </a>
                  <a
                    href={buildWebsiteUrl(
                      currentLanguage == "en" ? "/e-mobility" : "/e-mobilitaet/"
                    )}
                    className="text-decoration-none py-3 border-bottom px-2 px-sm-3 text-blue fontSize18Medium lineHeight24 header-nav-link"
                  >
                    {t("E-Mobility")}
                  </a>
                  <a
                    href={buildWebsiteUrl(
                      currentLanguage == "en"
                        ? "/help-support"
                        : "/hilfe-support/"
                    )}
                    className="text-decoration-none py-3 border-bottom px-2 px-sm-3 text-blue fontSize18Medium lineHeight24 header-nav-link"
                  >
                    {t("Help & Support")}
                  </a>

                  <div className="border-bottom">
                    <button
                      className="w-100 text-start border-0 bg-transparent py-3 px-2 px-sm-3 text-blue fontSize18Medium lineHeight24 d-flex align-items-center justify-content-between"
                      onClick={toggleMobileAboutUs}
                    >
                      {t("About Us")}
                      {isMobileAboutUsOpen ? (
                        <FaChevronUp size={14} />
                      ) : (
                        <FaChevronDown size={14} />
                      )}
                    </button>

                    {isMobileAboutUsOpen && (
                      <div className="bg-white">
                        <a
                          href={buildWebsiteUrl(
                            currentLanguage == "en"
                              ? "/our-company"
                              : "/ueber-uns/unser-unternehmen/"
                          )}
                          className="d-block text-decoration-none py-2 px-4 px-sm-5 text-blue fontSize16Medium lineHeight24 header-nav-link"
                        >
                          {t("Our Company")}
                        </a>
                        <a
                          href={buildWebsiteUrl(
                            currentLanguage == "en"
                              ? "/our-energy-network"
                              : "/ueber-uns/unser-energienetz/"
                          )}
                          className="d-block text-decoration-none py-2 px-4 px-sm-5 text-blue fontSize16Medium lineHeight24 header-nav-link"
                        >
                          {t("Our Energy Network")}
                        </a>
                        <a
                          href={buildWebsiteUrl(
                            currentLanguage == "en"
                              ? "/news-room"
                              : "/ueber-uns/aktuelles/#/"
                          )}
                          className="d-block text-decoration-none py-2 px-4 px-sm-5 text-blue fontSize16Medium lineHeight24 header-nav-link"
                        >
                          {t("News Room")}
                        </a>
                      </div>
                    )}
                  </div>

                  <a
                    href={buildWebsiteUrl(
                      currentLanguage == "en" ? "/careers" : "/karriere/"
                    )}
                    className="text-decoration-none py-3 border-bottom px-2 px-sm-3 text-blue fontSize18Medium lineHeight24 header-nav-link"
                  >
                    {t("Careers")}
                  </a>
                  <a
                    href={buildWebsiteUrl(
                      currentLanguage == "en"
                        ? "/help-support/#Contactus"
                        : "/hilfe-support/#Contactus"
                    )}
                    className="text-decoration-none py-3 px-2 px-sm-3 text-blue fontSize18Medium lineHeight24 header-nav-link"
                  >
                    {t("Contact")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Header;
